import React from "react"
import loadable from "@loadable/component"
import { Ruta } from "../../../Ruta"
import { ContratoSection } from "../ContratoSection"
import { Card } from "../PlanesCards/Card"

import logoSilver from "../../../../images/planes/SKOL_SILVER.svg"
import logoGold from "../../../../images/planes/SKOL_GOLD.svg"
import logoPlatinum from "../../../../images/planes/SKOL_PLATINUM.svg"

import "./landing.scss"

const PlanesCards = loadable(() => import("../PlanesCards"))

const planTextList = [
  "Mantenimiento Preventivo",
  "Diagnóstico Telefónico",
  "Mantenimiento Correctivo",
  "Gestión remota",
  "Asesoramiento",
  "Soporte Técnico Telefónico",
  "Gestión de recambio de partes",
  "Actualización de Software",
  "Servicio/Respuesta Onsite Preferencial",
  "Valor preferencial en hora adicional",
]

const silverPlanList = [1, 1, 0, 0, 0, 1, 1, 1, 0, 0]
const goldPlanList = [1, 1, 1, 1, 1, 1, 1, 1, 0, 0]
const platinumPlanList = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1]

export const LandingSection = ({ classTitle, rutaTitle, subRuta, title }) => {
  const recomendado = true
  return (
    <>
      <Ruta
        rutaTitle={rutaTitle}
        subRuta={subRuta}
        title={title}
        classTitle={classTitle}
      />
      <div
        className={`${classTitle}-subtitle-container`}
        data-sal="slide-up"
        data-sal-delay="200"
        data-sal-easing="ease"
      >
        <h3>
          <span>Skol Solutions</span> cuenta con 3 tipos de contrato diferente
          adecuados, cada uno de ellos, a las necesidades de cada tipo de
          cliente.
        </h3>
      </div>
      <div className={`${classTitle}-planes-cards-container`}>
        <PlanesCards
          classTitle={classTitle}
          planTextList={planTextList}
          silverPlanList={silverPlanList}
          goldPlanList={goldPlanList}
          platinumPlanList={platinumPlanList}
        />
      </div>
      <ul className={`${classTitle}-cards-container`}>
        <Card
          title="silver"
          planList={silverPlanList}
          planTextList={planTextList}
          classTitle={classTitle}
          logo={logoSilver}
        />
        <Card
          title="gold"
          planList={goldPlanList}
          planTextList={planTextList}
          classTitle={classTitle}
          logo={logoGold}
          recomendado={recomendado}
        />
        <Card
          title="platinum"
          planList={platinumPlanList}
          planTextList={planTextList}
          classTitle={classTitle}
          logo={logoPlatinum}
        />
      </ul>

      <ContratoSection classTitle={classTitle} />
    </>
  )
}
